import { render, staticRenderFns } from "./asambleaFormForm.vue?vue&type=template&id=51dc120b"
import script from "./asambleaFormForm.vue?vue&type=script&lang=js"
export * from "./asambleaFormForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports